import LowestRatesPropertiesContainerMobile from '../../../../components/containers/LowestRatesPropertiesContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadLowestRatesProperties';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'property-low-rates-calendar--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  containerConfig: {
    settings: {
      instance: LowestRatesPropertiesContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
